<template>
    <article class="result-card" v-bind:class="resultItem.Content.PropertyHasPhotos ? 'result-card--with-image' : ''">
        <div class="result-card__image-wrapper" v-if="resultItem.Content.PropertyHasPhotos || resultItem.Content.PropertyHasDocuments || resultItem.Content.PropertyHasVideo">
            <thumbnail-image :photo-id="propertyPhotoId" v-if="propertyPhotoId"></thumbnail-image>
        </div>
        <div class="result-card__inner flow">
            <div class="result-card__header">
                <h3 class="result-card__title">
                    <a :href="resultItem.Link.Url">
                        {{resultItem.Heading}}
                    </a>
                </h3>
                <span class="visually-hidden">Property</span>
            </div>
            <result-tags :tag-parents="resultItem.TagParents"></result-tags>
            <div class="result-card__content flow max-width-s">
                <p v-if="resultItem.Summary !== ''" v-html="resultItem.Summary"></p>
                <p v-if="resultItem.Content.PropertyRentalRent != 0" class="text-scale-medium"><strong>{{formatAskingPrice(resultItem.Content)}}</strong></p>
            </div>
            <div class="result-card__footer">
                <a :href="resultItem.Link.Url" class="btn">
                    Find out more
                    <span class="visually-hidden"> about {{resultItem.Heading}}</span>
                </a>
                <profile-actions :page-id="resultItem.Id.toString()"></profile-actions>
            </div>
        </div>
        <!--<div class="e-map" v-if="resultItem.Content && resultItem.Content.PropertyPhotos && resultItem.Content.PropertyPhotos.length > 1 && resultItem.Content.PropertyPhotos[1].MediaItem">
            <thumbnail-image :photo-id="resultItem.Content.PropertyPhotos[1].MediaItem.Id"></thumbnail-image>
        </div>-->
    </article>
</template>

<script>
    import ProfileActions from '@/components/Utils/profile-actions'
    import ThumbnailImage from '@/components/Utils/thumbnail-image'
    import ResultTags from '@/components/SiteSearch/result-tags'
    import { globalMixin } from '@/mixins/globalMixin.js'
    import { propertyMixin } from '@/mixins/propertyMixin.js'
    import { truncate } from '@/utils/strings.js'

    export default {
        components: {
            ProfileActions,
            ThumbnailImage,
            ResultTags
        },

        computed: {
            isLoggedIn: function () {
                return isLoggedIn
            },

            propertyPhotoId: function () {
                if (!this.resultItem.Content || !Array.isArray(this.resultItem.Content.PropertyPhotos)) {
                    return null
                }

                const firstPhoto = this.resultItem.Content.PropertyPhotos[0]

                if (!firstPhoto || !firstPhoto.MediaItem) {
                    return null
                }

                return firstPhoto.MediaItem.Id
            }
        },

        methods: {
            truncate: function (stringToTruncate) {
                return truncate(stringToTruncate)
            }
        },

        mixins: [globalMixin, propertyMixin],

        props: {
            resultItem: {
                required: true,
                type: Object
            },
            hideImage: {
                required: false,
                type: Boolean
            }
        }
    }
</script>
